<div class="empty-panel"></div>

<div class="side-panel">
    <div class="row">
        <div class="col title">{{ "CouponsList.PageTitle" | translate }}</div>
    </div>

    <form [formGroup]="searchForm" novalidate class="voffset-20">
        <div class="form-group form-horizontal">
            <div class="row voffset20">
                <div class="col-12">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "CouponsList.CodeSearchLabel" | translate
                        }}</label>
                        <div
                            class="form-group form-horizontal input-with-clear"
                        >
                            <i
                                class="fa fa-keyboard-o number-icon"
                                aria-hidden="true"
                            >
                            </i>
                            <input
                                placeholder="Type in coupon Code or Email"
                                class="form-control"
                                type="text"
                                formControlName="code"
                                hznTestId="coupons-list-code"
                            />
                            @if (showCodeClear()) {
                                <span
                                    class="input-with-clear-img"
                                    hznTestId="coupons-list-code-clear"
                                    (click)="onCodeClear()"
                                    >&#10006;</span
                                >
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div class="row voffset20">
                <div class="col-12">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "CouponsList.TypeSearchLabel" | translate
                        }}</label>
                        <bcu-drop-down-multiselect-cf2
                            hznTestId="coupons-list-type"
                            [options]="typeDropdownItems"
                            [shortenWhenAllSelected]="true"
                            [selectAllOption]="true"
                            (changed)="onTypesChanged($event)"
                        >
                        </bcu-drop-down-multiselect-cf2>
                    </div>
                </div>
            </div>

            <div class="row voffset20">
                <div class="col-12">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "CouponsList.CategorySearchLabel" | translate
                        }}</label>
                        <bcu-drop-down-multiselect-cf2
                            hznTestId="coupons-list-category"
                            [options]="categoryDropdownItems"
                            [shortenWhenAllSelected]="true"
                            [selectAllOption]="true"
                            (changed)="onCategoryChanged($event)"
                        >
                        </bcu-drop-down-multiselect-cf2>
                    </div>
                </div>
            </div>

            <div class="row voffset20">
                <div class="col-12">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "CouponsList.StatusSearchLabel" | translate
                        }}</label>
                        <bcu-drop-down-multiselect-cf2
                            hznTestId="coupons-list-status"
                            [options]="statusDropdownItems"
                            [shortenWhenAllSelected]="true"
                            [selectAllOption]="true"
                            (changed)="onStatusesChanged($event)"
                        >
                        </bcu-drop-down-multiselect-cf2>
                    </div>
                </div>
            </div>

            <div class="row voffset20">
                <div class="col-12">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "CouponsList.UsageTypeSearchLabel" | translate
                        }}</label>
                        <bcu-drop-down-multiselect-cf2
                            hznTestId="coupons-list-usage-type"
                            [options]="usageTypeDropdownItems"
                            [shortenWhenAllSelected]="true"
                            [selectAllOption]="true"
                            (changed)="onUsageTypesChanged($event)"
                        >
                        </bcu-drop-down-multiselect-cf2>
                    </div>
                </div>
            </div>

            <div class="row voffset20">
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "CouponsList.DateFrom" | translate
                        }}</label>
                        <bcui-date-picker-input2
                            class="date-picker"
                            formControlName="dateFrom"
                            hznTestId="coupons-list-date-from"
                            name="dateFrom"
                        >
                        </bcui-date-picker-input2>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "CouponsList.DateTo" | translate
                        }}</label>
                        <bcui-date-picker-input2
                            class="date-picker"
                            formControlName="dateTo"
                            hznTestId="coupons-list-date-to"
                            name="dateTo"
                            inputMask="00/00/0000"
                            inputDateFormat="MM/DD/YYYY"
                        >
                        </bcui-date-picker-input2>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
